import { useState, useEffect } from "react";
import {
  getCurrentPath,
  subscribeToRouteChanges,
  navigateTo,
  routes,
} from "./Router";

export const useRouter = () => {
  const [path, setPath] = useState(getCurrentPath);

  useEffect(() => {
    const unsubscribe = subscribeToRouteChanges(() => {
      setPath(getCurrentPath());
    });
    return unsubscribe;
  }, []);

  const currentRoute = routes.find((route) => route.path === path);

  return {
    path,
    navigate: navigateTo,
    currentRoute: currentRoute ?? null,
  };
};